import React, { useState, useEffect } from "react";
import { nameConfig, emailConfig, phoneConfig } from "../Config/formConfig";
import { FORM_API_URL } from "../Config/chatProps";
import "../components/form.css";
import ReactGA from "react-ga4";

const FormComponent = ({ chatConfig, onSubmit, sessionId, guestId }) => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    sessionId: sessionId,
    guestId: guestId,
    campaignId: chatConfig?.campaignId,
    campaignName: chatConfig?.campaignName,
  });
  const [submitted, setSubmitted] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const formStyle = {
    backgroundColor: chatConfig?.footer?.sendButton?.color,
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "20px",
    cursor: "pointer",
    fontFamily: "Montserrat",
    fontSize: "14px",
    transition: "white 0.3s ease",
  };

  useEffect(() => {
    let intervalId;
    if (loading) {
      intervalId = setInterval(() => {
        setLoading((prevLoading) => !prevLoading);
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [loading]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === nameConfig.fieldName) {
      setNameError("");
      // Validate name
      const nameRegex = nameConfig.validationRegex;
      if (!nameRegex.test(value)) {
        if (!nameConfig.validationLetters.test(value)) {
          setNameError(nameConfig.validationErrorMessage);
        } else {
          setNameError(nameConfig.lengthErrorMessage);
        }
      }
    } else if (name === emailConfig.fieldName) {
      setEmailError("");
      // Validate email
      const emailRegex = emailConfig.validationRegex;
      if (!emailRegex.test(value)) {
        setEmailError(emailConfig.validationErrorMessage);
      }
    } else if (name === phoneConfig.fieldName) {
      setPhoneError("");
      // Validate phone number
      if (!validatePhone(value)) {
        setPhoneError(phoneConfig.validationErrorMessage);
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { phone, name, email } = formData;
  
    let isValid = true;
  
    if (chatConfig?.body?.leadFields?.mobile === 'True') {
      if (!validatePhone(phone)) {
        setPhoneError(phoneConfig.validationErrorMessage);
        isValid = false;
      }
    }
  
    if (chatConfig?.body?.leadFields?.fullName === 'True') {
      const nameRegex = nameConfig.validationRegex;
      if (!nameRegex.test(name)) {
        if (!nameConfig.validationLetters.test(name)) {
          setNameError(nameConfig.validationErrorMessage);
        } else {
          setNameError(nameConfig.lengthErrorMessage);
        }
        isValid = false;
      }
    }
  
    if (chatConfig?.body?.leadFields?.email === 'True') {
      const emailRegex = emailConfig.validationRegex;
      if (!emailRegex.test(email)) {
        setEmailError(emailConfig.validationErrorMessage);
        isValid = false;
      }
    }
  
    if (isValid) {
      setLoading(true);
      try {
        const urlAddUser = FORM_API_URL+`?SUB-DOMAIN=${chatConfig?.subDomain}`;
        const response = await fetch(urlAddUser, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
        if (response.ok) {
          ReactGA.event({
            category: 'Leads',
            action: 'leadGenerated',
            label: 'Lead Generation',
          });
          onSubmit(formData);
          setSubmitted(true);
        } else {
          const errorMessage = await response.text();
          console.error('Server Error:', errorMessage);
          setErrorMessage('Server Error: ' + errorMessage);
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('Error submitting form. Please try again later.');
      } finally {
        setLoading(false);
      }
    }
  };
  

  // Phone number validation function
  const validatePhone = (phoneNumber) => {
    const phoneRegex = phoneConfig.validationRegex;
    return phoneRegex.test(phoneNumber);
  };

  return (
    <div className="form-container">
      {submitted ? (
        <div>
        <p className="mb-2">Thank you for your submission!</p>
        {chatConfig?.body?.leadFields?.fullName === 'True' && (
          <p>Name: {formData.name}</p>
        )}
        {chatConfig?.body?.leadFields?.email === 'True' && (
          <p>Email: {formData.email}</p>
        )}
        {chatConfig?.body?.leadFields?.mobile === 'True' && (
          <p>Phone: {formData.phone}</p>
        )}
      </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="mb-3">Please Enter your Details:</div>
          {chatConfig?.body?.leadFields?.fullName === "True" && (
            <label>
              Name:
              <input
                type="text"
                name={nameConfig.fieldName}
                value={formData[nameConfig.fieldName]}
                onChange={handleChange}
                required
              />
              {nameError && <span className="error">{nameError}</span>}
            </label>
          )}
          <br />
          {chatConfig?.body?.leadFields?.email === "True" && (
            <label>
              Email:
              <input
                type="email"
                name={emailConfig.fieldName}
                value={formData[emailConfig.fieldName]}
                onChange={handleChange}
                required
              />
              {emailError && <span className="error">{emailError}</span>}
            </label>
          )}
          <br />
          {chatConfig?.body?.leadFields?.mobile === "True" && (
            <label>
              Phone:
              <input
                type="tel"
                name={phoneConfig.fieldName}
                value={formData[phoneConfig.fieldName]}
                onChange={handleChange}
                onBlur={handleChange} // Trigger validation on blur
                required
              />
              {phoneError && <span className="error">{phoneError}</span>}
            </label>
          )}
          <br />
          {errorMessage && <span className="error">{errorMessage}</span>}
          {loading ? (
            <div className="spinner">
              <div className="bounce1"></div>
              <div className="bounce2"></div>
              <div className="bounce3"></div>
            </div>
          ) : (
            <button id="submitBtn" type="submit" style={formStyle}>
              Submit
            </button>
          )}
        </form>
      )}
    </div>
  );
};

export default FormComponent;
